const assetPath = (path:string) => {
  const prefix = process.env.PUBLIC_URL || '';
  return prefix+path;
}

export default assetPath;